import { render, staticRenderFns } from "./pTitle.vue?vue&type=template&id=6708e1d5&scoped=true"
import script from "./pTitle.vue?vue&type=script&lang=js"
export * from "./pTitle.vue?vue&type=script&lang=js"
import style0 from "./pTitle.vue?vue&type=style&index=0&id=6708e1d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708e1d5",
  null
  
)

export default component.exports